/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1CourseregistrationSharedPoloListQueryResponse,
  GetApiV1CourseregistrationSharedPoloListQueryParams,
  GetApiV1CourseregistrationSharedPoloList401,
  GetApiV1CourseregistrationSharedPoloList500,
} from "../../types/courseRegistrationSharedController/GetApiV1CourseregistrationSharedPoloList.ts";

function getGetApiV1CourseregistrationSharedPoloListUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/courseregistration/shared/polo-list` as const,
  };
  return res;
}

/**
 * @description Retorna a lista de polos disponíveis para o usuário autenticado. Se o parâmetro 'main' for verdadeiro, adiciona a opção '- Pecege Online -' no início da lista. Usuários com papel Polo recebem apenas os polos vinculados a eles; demais usuários recebem todos os polos ativos filtrados pela empresa. **(Requer Authorization para autenticação)**
 * @summary Retorna a lista de polos para dropdown (Requer Authorization para autenticação)
 * {@link /api/v1/courseregistration/shared/polo-list}
 */
export async function getApiV1CourseregistrationSharedPoloList(
  params?: GetApiV1CourseregistrationSharedPoloListQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1CourseregistrationSharedPoloListQueryResponse,
    ResponseErrorConfig<
      | GetApiV1CourseregistrationSharedPoloList401
      | GetApiV1CourseregistrationSharedPoloList500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1CourseregistrationSharedPoloListUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
